<script>
import moment from 'moment-timezone';

import { SectionPostTypes } from '../constants';

export default {
  name: 'CpEventCard',
  components: {
    CpImage: require('../image').default,
    CpGrid: require('../grid').default,
    CpGridItem: require('../grid-item').default,
    CpButton: require('../button').default,
    CpBox: require('../box').default,
    CpBoxContent: require('../box-content').default,
    CpButtonLink: require('../button-link').default,
    CpIcon: require('../icon').default,
    CpSocialShareDialog: require('../dialogs/social-share').default,
    LikeActionButton: require('../social-feed/actions/like-action-button').default,
    CpLikesProfiles: require('../likes/likes-profiles').default,
    CpDialog: require('../dialog').default,
    CommentActionButton: require('../social-feed/actions/comment-action-button').default,
    CpCommentsPost: require('../comments/box-comments').default,
    CpDialogAuthForm: require('../auth-form/dialog-auth-form').default,
    CpShowInteractionsCount: require('../components/ShowInteractionsCount').default,
    CpShowImageInCard: require('../components/ShowImageInCard').default,
  },
  directives: {
    margin: require('../directives/margins').margin,
    marginTop: require('../directives/margins').marginTop,
    marginRight: require('../directives/margins').marginRight,
    marginBottom: require('../directives/margins').marginBottom,
    marginLeft: require('../directives/margins').marginLeft,
  },
  props: {
    event: Object,
    actionButtonsDisabled: {
      type: Boolean,
      default: false,
    },
    forShare: { type: Boolean, default: false }, //Is shared in explore
  },
  data() {
    return {
      loading: false,
      showShareModal: false,
      showLikesModal: false,
      comments_count: this.event.comments_count,
      likes_count: this.event.likes_count,
      showAuthModal: false,
      type: SectionPostTypes.EVENTS,
    };
  },
  computed: {
    authUser() {
      return this.$root.authUser;
    },
    badge() {
      return this.event.status_now;
    },
    dateFormated() {
      if (this.event.status == 'canceled') {
        return 'canceled';
      }

      const start = new Date(this.event.start);
      const dateUTC = Date.UTC(start.getFullYear(), start.getMonth(), start.getDate(), start.getHours(), start.getMinutes(), 0, 0);
      const localStart = new Date(dateUTC);

      const today = this.isToday(this.event.start);
      let date;
      if (today) {
        date = 'TODAY AT ' + moment(localStart).format('h:mm A');
      } else {
        date = moment(localStart).format('ddd, MMM D [AT] h:mm A');
      }

      return date + ' (EST)';
    },
  },
  methods: {
    eventDetails(id) {
      return '/events/' + id;
    },
    handleShareModal() {
      this.showShareModal = !this.showShareModal;
    },
    goToGroup(id) {
      window.location.href = `/groups/${id}`;
    },
    joinEvent() {
      if (!this.authUser) {
        this.showAuthModal = true;
      } else {
        this.handleJoinEvent();
      }
    },
    handleJoinEvent() {
      if (this.event.is_owner) {
        // Start livestream
        window.location.href = `/events/${this.event.id}/livestream/join`;
      } else {
        // View broadcast
        window.location.href = `/livestreams/${this.event.session_id}`;
      }
    },
    handleCloseButton() {
      this.showAuthModal = false;
    },
    isToday(date) {
      const current = new Date();

      const start = new Date(date);
      const startUTC = Date.UTC(start.getFullYear(), start.getMonth(), start.getDate(), start.getHours(), start.getMinutes(), 0, 0);
      const localStart = new Date(startUTC);

      const startYYYYMMDD = moment(localStart).format('YYYY-MM-DD');
      const currentYYYYMMDD = moment(current).format('YYYY-MM-DD');

      return currentYYYYMMDD == startYYYYMMDD;
    },
    handleLikesModal() {
      this.showLikesModal = !this.showLikesModal;
    },
    handleCountLikes(value) {
      if (value) {
        this.likes_count = this.likes_count + 1;
      } else {
        this.likes_count = this.likes_count - 1;
      }
    },
    setCount(type) {
      this.comments_count++;
    },
    setCommentsCount(action) {
      action == 'remove' ? this.comments_count-- : this.comments_count++;
    },
  },
  watch: {
    lobby(newResult) {
      this.comments_count = newResult.comments_count;
    },
  },
};
</script>

<template>
  <div class="social-feed-post-wrapper">
    <div>
      <div class="statusContainer">
        <p class="primary6-color content-5">{{ dateFormated.toUpperCase() }}</p>
        <span
          v-if="badge !== 'CANCELED'"
          :class="{
            footnote: true,
            liveTag: badge == 'LIVE' || badge == 'HAPPENING NOW',
            'nuetral6-color upcomingTag': badge === 'UPCOMING',
          }"
          v-margin-left="0.5"
          >{{ badge }}</span
        >
      </div>

      <h3 class="neutral6-color content-5">{{ event.title }}</h3>

      <CpShowImageInCard :image="event.image" />

      <div v-margin-top="0.5">
        <p @click="goToGroup(event.group.id)" class="content-3" v-margin-top="0" v-margin-bottom="0" style="cursor: pointer">
          Event by <span style="color: #1847ed">{{ event.group.title }}</span>
        </p>
        <p v-if="event.address" class="content-2" style="color: #808080" v-margin-top="0" v-margin-bottom="0">{{ event.address }}</p>
      </div>
      <div v-margin-top="0.5">
        <p class="nuetral4-color content-3">{{ event.attendees_count + 1 || 0 }} Attendees</p>
      </div>

      <!-- Handle buttons General -->
      <div v-if="!actionButtonsDisabled">
        <cp-grid v-if="badge === 'UPCOMING'" justify="space-between" v-margin-top="1">
          <cp-grid-item :span="$root.isMobile ? 12 : 6">
            <cp-button-link block :href="eventDetails(event.id)"><span class="caption1">Details</span></cp-button-link>
          </cp-grid-item>
          <cp-grid-item v-if="event.status !== 'canceled'" :span="$root.isMobile ? 12 : 6">
            <cp-button primary block @click="handleShareModal()"
              ><span class="shareBtnContainer"
                ><i class="fa fa-share share-icon" /><span v-if="!$root.isMobile" class="caption1">&nbsp;Share </span></span
              ></cp-button
            >
          </cp-grid-item>
        </cp-grid>
        <cp-grid v-else-if="badge === 'LIVE'" justify="spaceBetween">
          <cp-grid-item :span="$root.isMobile ? 6 : 6">
            <cp-button-link :disabled="loading" block :href="eventDetails(event.id)"><span class="caption1">Details</span></cp-button-link>
          </cp-grid-item>
          <cp-grid-item :span="$root.isMobile ? 5 : 5">
            <cp-button @click="joinEvent" :disabled="loading" :loading="loading" primary block><span class="caption1">Join</span></cp-button>
          </cp-grid-item>
          <cp-grid-item :span="1">
            <cp-button noborder @click="handleShareModal()"><i class="fa fa-share share-primary-icon" /></cp-button>
          </cp-grid-item>
        </cp-grid>
        <cp-grid v-else>
          <cp-grid-item :span="$root.isMobile ? 12 : 6">
            <cp-button-link block :href="eventDetails(event.id)"><span class="caption1">Details</span></cp-button-link>
          </cp-grid-item>
          <cp-grid-item v-if="event.status !== 'canceled'" :span="$root.isMobile ? 12 : 6">
            <cp-button primary block @click="handleShareModal()"
              ><span class="shareBtnContainer"
                ><i class="fa fa-share share-icon" /><span v-if="!$root.isMobile" class="caption1">&nbsp;Share </span></span
              ></cp-button
            >
          </cp-grid-item>
        </cp-grid>
      </div>

      <div v-if="!forShare" style="margin-top: 10px !important">
        <CpShowInteractionsCount :type="type" :id="event.id" :likesCount="likes_count" :commentsCount="comments_count" :handleLikesModal="handleLikesModal" />
      </div>

      <cp-dialog v-if="showLikesModal">
        <cp-likes-profiles :count-likes="likes_count" :id="event.id" :type="'events'" @close="handleLikesModal"></cp-likes-profiles>
      </cp-dialog>

      <div v-if="!forShare" class="social-feed-post-actions">
        <div class="post-action-button like">
          <like-action-button type="events" :id="event.id" :liked="event.liked" :onSuccess="handleCountLikes" />
        </div>
        <div class="post-action-button comment">
          <comment-action-button :type="type" :id="event.id" />
        </div>
        <div class="post-action-button share">
          <cp-social-share-dialog
            v-if="showShareModal"
            class="feed"
            :openShare="true"
            :handleShareModal="handleShareModal"
            :allow-share-feed="true"
            :type="'events'"
            :post="event"
            share-category="Event"
            share-button-class="button--noborder"
            :url="event.permalink"
            title="Event found via CrowdBlue - Social Network For Politics"
            :description="`Wanted to share this event I found on CrowdBlue, the Social Network for Politics.`"
            hashtags="crowdBlue,politics,political crowdfunding"
            twitter-user="crowdblue"
          />
        </div>
      </div>
    </div>

    <cp-comments-post v-show="!forShare" :id="event.id" :type="type" :setCount="setCommentsCount">
    </cp-comments-post>
    <cp-social-share-dialog
      v-if="showShareModal"
      class="feed"
      :openShare="true"
      :handleShareModal="handleShareModal"
      :allow-share-feed="true"
      :type="'events'"
      :post="event"
      share-category="Event"
      share-button-class="button--noborder"
      :url="event.permalink"
      title="Event found via CrowdBlue - Social Network For Politics"
      :description="`Wanted to share this event I found on CrowdBlue, the Social Network for Politics.`"
      hashtags="crowdBlue,politics,political crowdfunding"
      twitter-user="crowdblue"
    />
    <cp-dialog-auth-form v-if="showAuthModal" :handleCloseButton="handleCloseButton" showSignUp :callback-action="handleJoinEvent" />
  </div>
</template>

<style scoped>
div.social-feed-post-wrapper {
  width: 100%;
  padding: 1.5em;
  border-bottom: 2px solid var(--neutral3);
  margin-bottom: 2.5em;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: auto;
}

div.social-feed-wrapper {
  display: flex;
  flex-direction: column;
}

.social-feed-post-wrapper > * {
  width: 100%;
}

.finishedTag,
.liveTag,
.upcomingTag {
  padding: 4px 8px;
  border-radius: 4px;
}

.finishedTag,
.liveTag {
  background-color: var(--primary0);
  color: white;
}

.upcomingTag {
  background-color: var(--caution);
}
.statusContainer {
  display: flex;
  align-items: center;
}

.image {
  width: 100%;
  max-height: 200px;
  object-fit: cover;
  border-radius: 4px;
}

.shareBtnContainer {
  display: flex;
  align-items: center;
}

.share-icon,
.share-primary-icon {
  font-size: 18px;
}

.share-icon {
  color: var(--white);
  padding-right: 10px;
}

.share-primary-icon {
  color: var(--primary);
}

.btnLeft {
  margin: 16px 0px 16px 4px;
}

.btnRight {
  margin: 16px 0px;
}

@media only screen and (max-width: 768px) {
  .btnLeft {
    margin: 16px 4px;
  }

  .share-icon {
    padding-right: 0px;
  }
}
</style>
